// Tour/Tutorial
export const nextLocationIDs = 'nextLocationIDs';
export const mainContentObscured = 'mainContentObscured';
export const tourCurrentArticle = 'tourCurrentArticle';

// packageSyncer
export const packageSyncerProgress = 'packageSyncerProgress';
export const packageSyncerPartState = 'packageSyncerPartState';

// Quiz
export const quizResult = 'quizResult';
export const quizCurrentStoreObject = 'quizCurrentStoreObject';
// History
export const historyPrev = 'historyPrev';
export const historyNext = 'historyNext';
export const historyCur = 'historyCur';

// media
export const activeMedia = 'activeMedia';

// main
export const articleCodeMap = 'articleCodeMap';

// viewState
export const viewStateAriaHideMainElements = 'viewStateAriaHideMainElements';

// Dmx
export const dmxArticles = 'dmxArticles';

// language
export const i18Notifyer = 'i18Notifyer';
export const currentLanguage = 'currentLanguage';
export const currentDefaultLanguage = 'currentDefaultLanguage';
export const possibleLanguages = 'possibleLanguages';

// global config
export const globalConfig = 'globalConfig';

// values dependend by router
export const currentExhibition = 'currentExhibition';
export const exhibitions = 'exhibitions';
export const getExhibition = 'getExhibition';
export const currentArticle = 'currentArticle';
export const currentArticleContent = 'currentArticleContent';
export const currentGlossaryContent = 'currentGlossaryContent';
export const currentCalendarEventContent = 'currentCalendarEventContent';

// BeaconStufff
export const beaconSettings = 'beaconSettings';
export const currentBeacons = 'currentBeacons';
export const variableStorage = 'variableStorage';
export const viewStateString = 'viewStateString';

// Audio player
export const activeMediaID = 'activeMediaID';
export const audioSource = 'audioSource';
export const audioIsActive = 'audioIsActive';

// Video source
export const videoSource = 'videoSource';
export const videoIsActive = 'videoIsActive';

// Swipe
export const pageTransitionSwipe = 'pageTransitionSwipe';

// scroll
export const getScrolledArticlePosition = 'getScrolledArticlePosition';
